import $ from 'jquery';
import './autosize';
import initCollapseSidebarOnWindowResize from './collapse_sidebar_on_window_resize';
import initCopyToClipboard from './copy_to_clipboard.js?vue3';
import installGlEmojiElement from './gl_emoji.js?vue3';
import initCopyAsGFM from './markdown/copy_as_gfm.js?vue3';
import { initQuickSubmit } from './quick_submit.js?vue3';
import { initToastMessages } from './toasts.js?vue3';
import { initGlobalAlerts } from './global_alerts.js?vue3';
import './shortcuts/index.js?vue3';
import './toggler_behavior.js?vue3';
import './preview_markdown.js?vue3';
import './configure_path_helpers';

if (gon.features?.findAndReplace) {
  import(/* webpackChunkName: 'findAndReplace' */ './find_and_replace').catch(() => {});
}

installGlEmojiElement();
initCopyAsGFM();
initCopyToClipboard();
initCollapseSidebarOnWindowResize();
initQuickSubmit();
initToastMessages();
initGlobalAlerts();

window.requestIdleCallback(
  () => {
    // Check if we have to Load GFM Input
    const $gfmInputs = $('.js-gfm-input:not(.js-gfm-input-initialized)');
    if ($gfmInputs.length) {
      import(/* webpackChunkName: 'initGFMInput' */ './markdown/gfm_auto_complete.js?vue3')
        .then(({ default: initGFMInput }) => {
          initGFMInput($gfmInputs);
        })
        .catch(() => {});
    }
  },
  { timeout: 500 },
);
